import type { DeepPartial } from '@luna/utils-ts';
import { FLAG } from '@shared/products-types';

import type { Statements } from '../../types/Statements';

export const statementsCZFeatureConfig: DeepPartial<Statements> = {
    hasSettings: true,
    sendStatementIdAsQueryParam: true,
    showCoreStatements: true,
    statementColumns: ['number', 'statementDate', 'periodicity', 'flag', 'actions'],
    statementNumberVisibilityFlags: [
        FLAG.consignmentContractAcc,
        FLAG.assetManagementAcc,
        'ASSET_MANAGEMENT_ACC',
        'CONSIGNMENT_CONTRACT_ACC',
    ],
    statementsBaseUrl: 'netbanking/cz/my/securities',
    supportedStatementTypes: ['ALL', 'TRANSACTIONS', 'PORTFOLIO', 'AMT', 'EX_ANTE'],
    fileDownload: true,
};
